import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
}));
export default function EditGroupModal({
  openModal,
  groupId,
  groupName,
  func,
}) {
  const classes = useStyles();
  const [newGroupName, setNewGroupName] = useState(groupName);
  const [processing, setProcessing] = useState(false);
  const [showInputError, setShowInputError] = useState(false);

  const json = {
    Id: groupId,
    Name: newGroupName,
  };

  const checkAllEntered = () => {
    if (newGroupName === "") {
      return false;
    }
    return true;
  };

  const callFunc = (json) => {
    if (checkAllEntered()) {
      func(json).then(() => {
        openModal(false);
      });
    } else {
      setShowInputError(true);
    }
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Edit Group Name
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <TextField
                  placeholder="Edit Group Name"
                  label="Edit Group Name"
                  variant="standard"
                  fullWidth
                  required
                  error={showInputError && newGroupName === ""}
                  value={newGroupName}
                  onChange={(e) => setNewGroupName(e.target.value)}
                />
                {showInputError && newGroupName === "" && (
                  <FormHelperText className={classes.error}>
                    Group Name Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => openModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => callFunc(json)}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
